<template>
  <div class="form-check">
    <input
      v-model="checked"
      class="form-check-input"
      type="checkbox"
      :id="name"
      :name="name"
      :disabled="disabled || saving"
      @click="save"
    >
    <label class="form-check-label" :for="name">{{label}}</label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    initialChecked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      saving: false,
      errors: null,
      checked: this.initialChecked,
    };
  },

  methods: {
    save() {
      this.saving = true;

      this.$nextTick(() => {
        const form = {};
        form[this.field] = {};
        form[this.field][this.name] = !this.checked;

        window.axios
          .put(`/profile/${this.id}`, form)
          .then(() => {
            this.saving = false;
            this.editing = false;
          })
          .catch((error) => {
            this.saving = false;
            this.errors = error.response.data.errors;
            throw new Error(error);
          });
      });
    },
  },
};
</script>
